import { ModuleRunsView } from './ModuleRunsView';

/** Модуль «Пакет руководству» (М5): консолидированный пакет KPI по всем
 *  направлениям за период. Собирается из уже утверждённых прогонов М1–М4 —
 *  документы не грузятся, поэтому форма прогона работает в режиме «без файлов»
 *  (см. ModuleRunsView, ветвление по `docTypes.length === 0`). Сам пакет
 *  показывается в карточке прогона (ExecPackCard). */
export function ExecPackReport() {
  return <ModuleRunsView moduleId="exec_pack" />;
}
